import { useCifraClient } from "../../cifra-client";

const { cifraClient } = useCifraClient();

export default {
  guardar(datos, options) {
    if (datos && datos.transporte_inscripcion && datos.transporte_inscripcion.id) {
      const url = `/transporte/inscripciones/${datos.transporte_inscripcion.id}`;
      return cifraClient.patch(url, datos, options);
    }

    return cifraClient.post('/transporte/inscripciones', datos, options);
  },
};
